/**
 * Created by Kevin on 2016-02-24.
 */
angular.module('flipto.core.enums')
    .constant('insertionTypes', [
        { id: "0", name: "Before Begin", description: "Appears before the element" },
        { id: "1", name: "After Begin", description: "Appears inside the element as the first child" },
        { id: "2", name: "Before End", description: "Appears inside the element as the last child" },
        { id: "3", name: "After End", description: "Appears after the element" }
    ]);